module.exports = {"views.checkoutSuccessMeditationStudio.success.heading":"成功！","views.checkoutSuccessMeditationStudio.success.body":"サブスクリプションが正常にアクティブ化されました。"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/ja/views/CheckoutSuccessMeditationStudio.json
// module id = 821
// module chunks = 0